module.exports = __webpack_public_path__ + "bcbea6562b16e22877cb362a0839d582.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth0Animation/components/Step4/step-4-placeholder.png
// module id = 1556
// module chunks = 0